import { safeParseJson } from './safeParseJson'

/**
 * キーの名称を渡すと、そのキーに対する localStorage の値を JSON 文字列として解析し、文字列によって記述されている値やオブジェクトを構築して返します。
 * 解析する文字列が有効な JSON でない場合、 undefined を返します。
 *
 * @template T - 解析後の型。
 * @param keyName - 値を取り出したいキーの名称
 * @returns 解析後の値。
 */
export function safeGetLocalStorageItem<T>(keyName: string): T | undefined {
  const raw = localStorage.getItem(keyName)

  return safeParseJson<T>(raw)
}
